import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 12, fill: "currentColor", opacity: 0.2 }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M7.875 16.958a.833.833 0 0 1-.833-.833v-8.25a.833.833 0 0 1 1.667 0v6.238l6.827-6.827a.833.833 0 0 1 1.178 1.179l-6.827 6.827h6.238a.833.833 0 0 1 0 1.666z",
      clipRule: "evenodd"
    }
  )
);
var SvgCircledDiagonalDownOutlinedFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CircledDiagonalDownOutlinedFilled_default = SvgCircledDiagonalDownOutlinedFilled;

export { CircledDiagonalDownOutlinedFilled_default as default };
